/* @flow */
import React from 'react';
import AuthActions from 'auth/AuthActions';
import Button from 'components/Button.jsx';
import ConfirmEmail from 'auth/components/ConfirmEmail.jsx';
import ConfirmPhone from 'auth/components/ConfirmPhone.jsx';
import Cookies from 'lib/Cookies';
import DividerText from 'components/DividerText.jsx';
import Electron from 'lib/Electron';
import Form from 'components/Form.jsx';
import FormCheckBox from 'components/FormCheckBox.jsx';
import FormInput from 'components/FormInput.jsx';
import GoogleSignIn from 'auth/components/GoogleSignIn.jsx';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import Notice from 'components/Notice.jsx';
import Row from 'components/Row.jsx';
import ToastActions from 'actions/ToastActions';
import Profile from 'entities/Profile';

import './styles/SignInForm.scss';

const mediumOfUid = (uid: string) => (uid.includes('@') ? 'email' : 'sms');

const SignInForm = React.createClass({
  propTypes: {
    initialUid: React.PropTypes.string,
  },

  getInitialState() {
    // Flow seems to have trouble with getInitialState()
    const uid = this.props.initialUid || '';
    return {
      error: false,
      signingIn: false,
      needsConfirmation: '',
      uid,
      medium: mediumOfUid(uid),
    };
  },

  // typecheck: ignore statement
  onPersistChange(event: SyntheticEvent) {
    const { target } = event;
    if (target instanceof window.HTMLInputElement) {
      Cookies.set('persist', target.checked);
    }
  },

  // typecheck: ignore statement
  onUidChange(event: SyntheticEvent) {
    const { target } = event;
    if (target instanceof window.HTMLInputElement) {
      const uid = target.value;
      this.setState({
        uid,
        medium: mediumOfUid(uid),
      });
    }
  },

  onProfileSuccess(profile: Profile) {
    if (profile.needsPassword()) {
      // send to partial account completion page
      this.setState(({ medium }) => ({ signingIn: false, needsConfirmation: medium }));
    } else {
      this.handleInvalidCredentials();
    }
  },

  onGoBack() {
    this.setState({ needsConfirmation: '' });
  },

  getPersistFromCookie() {
    if (typeof Cookies.get('persist') === 'undefined') {
      const defaultValue = Electron.isAvailable() ? 'true' : 'false';
      Cookies.set('persist', defaultValue);
    }

    return Cookies.get('persist') === 'true';
  },

  // if an account exists and it needs a password
  // send them the confirmation email and redirect them to an instruction page
  checkForAccountExistence() {
    Profile
      .fetchByIdentifier(this.state.uid)
      .then(this.onProfileSuccess)
      .catch(this.handleInvalidCredentials);
  },

  handleInvalidCredentials(err?: Object) {
    const uidErr = 'Invalid email address or phone number';
    const unregistered = err && err.statusCode === 404;
    const errorMessage = unregistered ? uidErr : `${uidErr} or password`;

    ToastActions.showErrorToast(errorMessage);
    this.setState({ signingIn: false, error: true });
  },

  handleSubmit(data: Object) {
    const { uid, password, persist } = data;

    AuthActions
      .signIn(uid, password, persist)
      .then(() => this.setState({ error: false }))
      .catch(err => {
        if (err && err.statusCode === 401) {
          this.checkForAccountExistence();
        } else {
          ToastActions.showErrorToast('There was an error logging in. Please try again later.');
          this.setState({ signingIn: false, error: true });
        }
      });

    this.setState({ signingIn: true });
  },

  renderCookieWarningIfNeeded() {
    if (Cookies.isEnabled()) {
      return null;
    }

    return (
      <Row>
        <Notice color="lava">
          Cookies are not enabled on your browser. Please enable cookies in your browser preferences
          to continue.
        </Notice>
      </Row>
    );
  },

  renderDefault() {
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          {this.renderCookieWarningIfNeeded()}
          <FormInput
            label="Email address or phone number"
            name="uid"
            autoComplete="username"
            placeholder="Email address or phone number"
            onChange={this.onUidChange}
            size="large"
            value={this.state.uid}
            showErrorAfterBlur
            required
            validations={
              this.state.medium === 'email' ?
                { isEmail: true } :
                { couldPlausiblyBeANorthAmericanPhoneNumber: true }
            }
            validationErrors={{
              isEmail: 'Invalid email. Please try again.',
              couldPlausiblyBeANorthAmericanPhoneNumber:
              'Invalid phone number or email address. Please try again.',
            }}
          />
          <div className="SignInForm-password">
            <FormInput
              label="Password"
              type="password"
              name="password"
              autoComplete="current-password"
              autofocus={!!this.state.uid}
              placeholder="Password"
              required
              size="large"
              validations="minLength:1"
            />
            <Link
              to="/forgot_password"
              query={this.state.uid ? { email: this.state.uid } : null}
              tabIndex="-1"
              className="SignInForm-forgotPassword"
              eventElementName="SignInForm-forgotPassword">
              Forgot?
            </Link>
          </div>
          <FormCheckBox
            name="persist"
            defaultChecked={this.getPersistFromCookie()}
            onChange={this.onPersistChange}
            label="Stay logged in"
          />
          <Button
            type="submit"
            level="primary"
            full
            disabled={this.state.signingIn}>
            Log in
          </Button>
        </Form>

        <DividerText text="or" uppercase />

        <GoogleSignIn />

        <Link
          href={LinkConstants.SIGN_UP}
          target={Electron.isAvailable() ? '_blank' : null}
          color="thunder"
          className="SignInForm-signUpLink"
          eventElementName="SignInForm-signUpLink">
          Don’t have an account? Sign up!
        </Link>
      </div>
    );
  },

  render() {
    if (this.state.needsConfirmation === 'sms') {
      return (
        <ConfirmPhone
          uid={this.state.uid}
          onGoBack={this.onGoBack}
        />
      );
    } else if (this.state.needsConfirmation === 'email') {
      return (
        <ConfirmEmail
          uid={this.state.uid}
          onGoBack={this.onGoBack}
        />
      );
    } else {
      return this.renderDefault();
    }
  },
});

export default SignInForm;



// WEBPACK FOOTER //
// ./src/auth/components/SignInForm.jsx